import React, { useEffect, useMemo, useState } from 'react';
import api from '../utils/api';

const useDiscountCampaign = () => {
  const [campaign, setCampaign] = useState(null);

  useEffect(() => {
    let mounted = true;
    api.get('/api/discount-campaign', { params: { _t: Date.now() } })
      .then((response) => mounted && setCampaign(response.data?.campaign || null))
      .catch(() => mounted && setCampaign(null));
    return () => { mounted = false; };
  }, []);

  return campaign;
};

const formatRemaining = (endsAt, now) => {
  const remaining = Math.max(0, new Date(endsAt).getTime() - now);
  const totalSeconds = Math.floor(remaining / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return { days, hours, minutes, seconds };
};

const DiscountBanner = () => {
  const campaign = useDiscountCampaign();
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!campaign?.ends_at || !campaign.show_timer) return undefined;
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [campaign]);

  const remaining = useMemo(() => campaign?.ends_at ? formatRemaining(campaign.ends_at, now) : null, [campaign, now]);
  if (!campaign) return null;

  return (
    <div className="fixed inset-x-0 top-0 z-[120] border-b border-emerald-300/30 bg-emerald-950 px-3 py-1 text-white shadow-lg">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-center text-[11px] font-semibold sm:text-xs">
        <span className="font-bold tracking-wide">{campaign.message || campaign.name}</span>
        <span className="text-emerald-200">{campaign.discount_percent}% off</span>
        {remaining && (
          <span className="inline-flex items-center gap-1 rounded-md bg-white/10 px-1.5 py-0.5 font-mono text-[10px] text-emerald-50">
            Ends in {remaining.days}d {String(remaining.hours).padStart(2, '0')}:{String(remaining.minutes).padStart(2, '0')}:{String(remaining.seconds).padStart(2, '0')}
          </span>
        )}
      </div>
    </div>
  );
};

export { useDiscountCampaign };
export default DiscountBanner;
